import {API} from '../API';

export class PersonService {

  async savePerson(contact, data) {
    let method = 'post';
    let url = `contacts/${contact.id}/people`;
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deletePerson(contact, person) {
    return (await API.getConnection())
      .delete(`contacts/${contact.id}/people/${person.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
